import Swiper from "swiper/bundle";

export function idxFunc() {
  const swiper = new Swiper('.swiper', {
    speed: 1000,
    loop: false,
    autoplay: {
      delay: 10000,
    },
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    slidesPerView: 'auto',
    spaceBetween: 10,  
    breakpoints: {
      768: {
        spaceBetween: 20,  
      }
    }
  });
}
